import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "primary-container"
}
const _hoisted_2 = { class: "py-16 px-6 rounded-xl bg-white border border-gray-200" }
const _hoisted_3 = { class: "text-center mb-4" }
const _hoisted_4 = { class: "text-gray-900 font-medium text-2xl" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "text-center flex flex-row justify-center items-center flex-wrap mb-6" }
const _hoisted_7 = { class: "h-5 w-5 me-2" }
const _hoisted_8 = { class: "h-5 w-5 me-3.5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "text-center mb-4 mt-6" }
const _hoisted_11 = {
  class: "flex flex-row justify-center mb-2",
  href: "https://www.wonde.com/za/home/",
  title: "Visit Wonde Website",
  target: "_blank"
}
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { class: "text-center flex flex-row justify-center items-center flex-wrap" }
const _hoisted_14 = { class: "h-5 w-5 me-2" }

import { ref } from "vue";
import EditSchoolComponent from "./EditSchoolComponent.vue";
import EditSchoolGroupComponent from "./EditSchoolGroupComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'EditSelectionComponent',
  setup(__props) {

const menuToggle = ref("");

// Function to show initial component
const showInitilaComponent = () => {
    menuToggle.value = "";
}


return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (menuToggle.value == '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('internal_tools.edit_selection_component.title')), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('internal_tools.edit_selection_component.subtitle')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (menuToggle.value = 'school-details')),
                class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white mt-4 mx-2 flex flex-row justify-center items-center flex-wrap"
              }, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-archive-school',
                    title: 'rl archive school',
                    "aria-hidden": "true"
                  })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('internal_tools.edit_selection_component.school_details')), 1)
              ]),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (menuToggle.value = 'school-group-details')),
                class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white mt-4 mx-2 flex flex-row justify-center items-center flex-wrap"
              }, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-school-group',
                    title: 'rl school group',
                    "aria-hidden": "true"
                  })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('internal_tools.edit_selection_component.edit_school_group')), 1)
              ])
            ]),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", _hoisted_11, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-wonde-logo',
                  title: 'rl wonde logo',
                  "aria-hidden": "true"
                })
              ]),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("internal_view.wonde.intro")), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_router_link, {
                to: "/main/internal-wonde-import",
                class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white mt-4 mx-2 flex flex-row justify-center items-center flex-wrap"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_rl_icon, {
                      icon: 'rl-archive-school',
                      title: 'rl archive school',
                      "aria-hidden": "true"
                    })
                  ]),
                  _createTextVNode(" Wonde School Import ")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (menuToggle.value == 'school-details')
      ? (_openBlock(), _createBlock(EditSchoolComponent, {
          key: 1,
          onUpdateValue: showInitilaComponent
        }))
      : _createCommentVNode("", true),
    (menuToggle.value == 'school-group-details')
      ? (_openBlock(), _createBlock(EditSchoolGroupComponent, {
          key: 2,
          onUpdateValue: showInitilaComponent
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})